import { useMemo } from "react";
import { useDrawer } from "../../features/admin/hooks/useDrawer";
import Icons from "../constants/icon.constant";
import Button from "./Button";
import SecondaryIcon from "./SecondaryIcon";
import { Drawer as DrawerRoot, DrawerContent } from "./ui/drawer";

export default function Drawer() {
  const { activeContent, onClose } = useDrawer();
  const isOpen = Boolean(activeContent);

  const headerIcon = useMemo(() => {
    const iconFactory = activeContent?.onBackPressed
      ? Icons.ArrowRight
      : Icons.Close;
    return iconFactory({ width: 16, height: 16 });
  }, [activeContent]);

  const handleHeaderAction = () => {
    if (activeContent?.onBackPressed) {
      activeContent.onBackPressed();
      return;
    }
    onClose();
  };

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      onClose();
    }
  };

  return (
    <DrawerRoot open={isOpen} onOpenChange={handleOpenChange} direction="right">
      {activeContent ? (
        <DrawerContent className="bg-sidebar-active text-white data-[vaul-drawer-direction=right]:w-full data-[vaul-drawer-direction=right]:max-w-[420px]">
          <div className="flex h-full flex-col p-4">
            <div className="flex items-center gap-2 pb-2">
              <Button
                variant="icon"
                className="hover:bg-white/10!"
                onClick={handleHeaderAction}>
                <SecondaryIcon icon={headerIcon} isActive />
              </Button>
              <p className="text-lg flex-1 text-center">
                {activeContent.title}
              </p>

              <div className="w-10" />
            </div>
            <div className="flex-1 overflow-y-auto pr-1">
              {activeContent.element}
            </div>
          </div>
        </DrawerContent>
      ) : null}
    </DrawerRoot>
  );
}
